export default __webpack_public_path__ + "static/media/640_dummy-2014-store01-mobile-de.26326aa6.png";